import React from 'react'
import { createContext, useState } from "react";
import AuthContext from "./AuthContext.js";
import StatusContext from "./StatusContext.js";
import ClientContext from "./ClientContext.js";
import axios from "axios"

import { config } from '../config.js';



const GlobalSearchContext = createContext();

export default GlobalSearchContext;

export const GlobalSearchProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])

    const [status, setStatus] = useState('');
   
    const {
        currentUser,
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
      
        changeLanguage,
        setIsLoading,
      
        setShowLoginDialog,
       
    } = React.useContext(StatusContext);

    const {
        availablecredits,

    } = React.useContext(ClientContext);
   
    const onGlobalSearch = (prompt) => {
        console.log('onGlobalSearch:', prompt)
        const text = ''
        SendRequest(prompt, text)
    }
    

    async function SendRequest(request, task) {
       
        setStatus('')
     
        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }
       
        if (request.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

      
        let rqst = task + request
      
        let req = {
            user:currentUser,
            request: rqst,
        
        }

        setIsLoading(true)
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/globalsearch/request", { req }, {
                withCredentials: true
            })

            //let server_response = JSON.parse(res.data);

            let server_response = res.data

            console.log("Global search prompt:", request)
            console.log("Global search response:", server_response)


        } catch (err) {
          
            //console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
          
        }
        setIsLoading(false)
    }

    
    

    return <GlobalSearchContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse,
        chatName,
        chatNames,
        setChatName,
        setChatNames,
     
        status,
        setStatus,
     
        onGlobalSearch,

    }}>
        {props.children}
    </GlobalSearchContext.Provider>
})